import { setCookie, TERMS_AGREEMENT, COOKIE_VALUE, CALL_ME_BACK_COOKIE } from '../utils/cookies';
import { getSettings } from '../selectors/settings';

export const SET_ADDITIONAL_SERVICE = 'DRSA/GLOBAL/SET_ADDITIONAL_SERVICE';
export const SET_PROVIDER_ARRIVAL = 'DRSA/GLOBAL/SET_PROVIDER_ARRIVAL';
export const SET_PROGRESS_BAR = 'DRSA/GLOBAL/SET_PROGRESS_BAR';
export const SET_COOKIE = 'DRSA/COREAPI/SET_COOKIE';
export const SET_OPTIONAL_COOKIES = 'DRSA/COREAPI/SET_OPTIONAL_COOKIES';
export const SET_NPS_CONSENT_ANSWER = 'DRSA/COREAPI/SET_NPS_CONSENT_ANSWER';

const initialState = {
  token: undefined,
  session: undefined,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ADDITIONAL_SERVICE:
      return { ...state, additionalService: action.payload };
    case SET_PROVIDER_ARRIVAL:
      return { ...state, providerArrival: action.payload };
    case SET_OPTIONAL_COOKIES:
      return { ...state, optionalCookies: { ...state.optionalCookies, ...action.payload } };
    case SET_NPS_CONSENT_ANSWER:
      return { ...state, npsAnswer: action.payload };
    default:
      return state;
  }
};

export const setTermsAgreementCookie = () => (dispatch, getState) => {
  const { COOKIE_DURATION: expires } = getSettings(getState());
  setCookie(TERMS_AGREEMENT, COOKIE_VALUE, {
    expires,
    secure: true,
    sameSite: 'Strict',
    httpOnly: true,
  });
  return { type: SET_COOKIE };
};

export const setCallMeBackCookie =
  (value = COOKIE_VALUE) =>
    () => {
      setCookie(CALL_ME_BACK_COOKIE, value);
      return { type: SET_COOKIE };
    };

export const setOptionalCookies = payload => ({ type: SET_OPTIONAL_COOKIES, payload });

export const setAdditionalService = payload => ({ type: SET_ADDITIONAL_SERVICE, payload });
export const setProviderArrival = payload => ({ type: SET_PROVIDER_ARRIVAL, payload });
export const setNpsConsentAnswer = payload => ({ type: SET_NPS_CONSENT_ANSWER, payload });

export const actions = { setTermsAgreementCookie, setCallMeBackCookie, setOptionalCookies };
export default { reducer, actions };
